import React from 'react';
import Sticky from '@wix/da-shared-react/pkg/Sticky';
import SubNavBarDesktopInner from './SubNavBarDesktopInner';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';

import s from './SubNavBarDesktop.scss';

export const SubNavBarDesktop = props => (
  <div className={s['root']}>
    <ErrorBoundary>
      <Sticky zIndex={parseInt(s['z-index'])}>
        {isSticky => <SubNavBarDesktopInner isSticky={isSticky} {...props} />}
      </Sticky>
    </ErrorBoundary>
  </div>
);

export default SubNavBarDesktop;
